<div class="container">
  <div class="row row-centered">
    <div class="col-md-6 col-xs-12 col-centered">
      <section id="error-msg">
        <br>
        <h5>Une erreur s'est produite. Cliquez <a [routerLink]="['/home']">ici</a> pour retourner à l'accueil de votre espace financier,
          ou <a [href]="mspUrl">ici</a> pour revenir à MySelogerPro</h5>
        <br>
      </section>
    </div>
  </div>
</div>
